import * as React from 'react'
import { CheckFilter } from '../CheckFilter/CheckFilter'

export function Filters({ filters, setFilters, metafieldFilters }) {
  const updateFilter = (key, value) => {
    setFilters((filters) => ({ ...filters, [key]: value }))
  }

  return (
    <>
      {metafieldFilters &&
        metafieldFilters.map((x) => {
          return (
            <CheckFilter
              key={x.key}
              name={x.key.split('_').join(' ')}
              items={x.values}
              selectedItems={filters[`metafield.${x.key}`]}
              setSelectedItems={(value) =>
                updateFilter(`metafield.${x.key}`, value)
              }
            />
          )
        })}
    </>
  )
}
